import { cx } from '@linaria/core';
import { useRef } from 'react';
import { ElementToolbar } from '@pm2/element-toolbar';
import { ComponentFrameworkTitle } from '@utils/component-framework';
import { header, elementToolbarPlaceholder, heading, contentWrapper, wrapper } from './_component.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { ImageHotspotsContent } from '../organism.content/_content.js';

function ImageHotspotsComponent(props) {
  const rootRef = useRef(null);
  return /*#__PURE__*/jsx("div", {
    ref: rootRef,
    children: /*#__PURE__*/jsxs("section", {
      className: cx(wrapper, props.className, props.context),
      children: [/*#__PURE__*/jsxs("header", {
        className: header,
        children: [props.node && /*#__PURE__*/jsx("div", {
          className: elementToolbarPlaceholder
        }), /*#__PURE__*/jsx(ComponentFrameworkTitle, {
          className: heading,
          title: props.component.envelope.Title,
          onCollapse: props.onCollapse,
          richtextDescription: props.context === "embedded" ? props.node?.meta.richTextDescription : undefined
        }), props.node && /*#__PURE__*/jsx(ElementToolbar, {
          node: props.node
        })]
      }), /*#__PURE__*/jsx("div", {
        className: cx(contentWrapper),
        children: /*#__PURE__*/jsx(ImageHotspotsContent, {
          component: props.component
        })
      })]
    })
  });
}

export { ImageHotspotsComponent };
//# sourceMappingURL=_component.js.map
